"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.World = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_1 = require("react");
var util_1 = require("../util");
var cardTextStyle = { wordWrap: "break-word", overflowWrap: "break-word" };
exports.World = (0, react_1.memo)(function World(props) {
    var world = props.world;
    return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Card.Content, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Item.Image, { floated: "left", size: "tiny", src: (0, util_1.imageUrl)(world.thumbnailImageUrl) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Header, { style: cardTextStyle, children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/w/".concat(world.id), children: world.name }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Meta, { style: cardTextStyle, children: world.authorName }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Description, { children: world.description })] }) }));
});
